/** 资料收集题：与后端 MaterialCollectService 规则一致（前端预校验） */

export const MATERIAL_COLLECT_TYPE = 'material_collect'
export const MATERIAL_MAX_BYTES = 10 * 1024 * 1024
/** 与后端 MaterialCollectService.MAX_ALLOWED_ATTACHMENTS 一致 */
export const MATERIAL_MAX_ATTACHMENT_COUNT = 999

const ALLOWED_EXT = new Set(['.jpg', '.jpeg', '.png', '.gif', '.pdf', '.doc', '.docx', '.zip', '.rar'])

export function extOfFilename(name) {
  if (!name || typeof name !== 'string') return ''
  const i = name.lastIndexOf('.')
  if (i < 0 || i >= name.length - 1) return ''
  return name.slice(i).toLowerCase()
}

export function validateMaterialFile(file) {
  if (!file) return '请选择文件'
  if (file.size > MATERIAL_MAX_BYTES) return '单个附件不能超过 10MB'
  const ext = extOfFilename(file.name)
  if (!ext || !ALLOWED_EXT.has(ext)) {
    return '不支持的文件格式，仅允许：图片(jpg/png/jpeg/gif)、PDF、Word(doc/docx)、zip、rar'
  }
  return ''
}

export function parseMaxAttachments(question) {
  if (!question) return 1
  if (question.maxMaterialAttachments != null) {
    const n = Number(question.maxMaterialAttachments)
    if (Number.isFinite(n) && n >= 1 && n <= MATERIAL_MAX_ATTACHMENT_COUNT) return Math.floor(n)
  }
  const raw = question.options
  if (!raw || typeof raw !== 'string') return 1
  try {
    const o = JSON.parse(raw)
    const n = Number(o && o.maxAttachments)
    if (Number.isFinite(n) && n >= 1 && n <= MATERIAL_MAX_ATTACHMENT_COUNT) return Math.floor(n)
  } catch (e) {
    void e
  }
  return 1
}

export function parseMaterialAnswer(raw) {
  if (raw == null) return { text: '', attachments: [] }
  if (typeof raw === 'object' && !Array.isArray(raw)) {
    const text = String(raw.text || '').trim()
    const attachments = Array.isArray(raw.attachments) ? raw.attachments : []
    return { text, attachments }
  }
  const s = String(raw || '').trim()
  if (!s) return { text: '', attachments: [] }
  try {
    const o = JSON.parse(s)
    if (o && typeof o === 'object') {
      return {
        text: String(o.text || '').trim(),
        attachments: Array.isArray(o.attachments) ? o.attachments : []
      }
    }
  } catch (e) {
    void e
  }
  return { text: '', attachments: [] }
}

export function stringifyMaterialAnswer(draft) {
  const text = draft && draft.text != null ? String(draft.text) : ''
  const attachments = draft && Array.isArray(draft.attachments) ? draft.attachments : []
  return JSON.stringify({ text, attachments })
}

export function isMaterialAnswerComplete(raw, question) {
  const max = parseMaxAttachments(question)
  const { text, attachments } = parseMaterialAnswer(raw)
  if (!text) return false
  if (!Array.isArray(attachments) || attachments.length !== max) return false
  return attachments.every((a) => a && (a.storageName || a.downloadUrl))
}

export function materialSubmitBlockedMessage(max) {
  return `需完善资料收集题文字说明并上传规定数量（${max} 个）附件后，才可提交试卷。单个附件不超过 10MB，格式：图片(jpg/png/jpeg/gif)、pdf、word、zip、rar。`
}
